export default "__VITE_ASSET__DK0dnaZx__"